module.exports = __webpack_public_path__ + "static/media/apard.1c56c721.png";